import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum, FilterIdEnum } from '../../enums'

import { SynonymsForm, SynonymsList } from '../../views'

import { ROUTER_CONSTS } from '../router.consts'
import { ENABLED_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

const SYNONYMS_PATHS = Object.assign(ROUTES_PATHS, {
  synonyms: 'synonyms',
})

export const SYNONYMS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.SYNONYM].list,
    path: SYNONYMS_PATHS.synonyms,
    component: SynonymsList,
    meta: {
      featureId: FeatureIdEnum.SYNONYM,
      filters: () => ({
        config: {
          [FilterIdEnum.LANG]: {
            enabled: true,
          },
        },
        extra: {
          [ENABLED_FILTER_CONFIG.id]: ENABLED_FILTER_CONFIG,
        },
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.SYNONYM].create,
    path: `${SYNONYMS_PATHS.synonyms}/${SYNONYMS_PATHS.actions.create}`,
    component: SynonymsForm,
    meta: {
      featureId: FeatureIdEnum.SYNONYM,
      titleI18nKey: 'createSynonym',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.SYNONYM].list,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.SYNONYM].update,
    path: `${SYNONYMS_PATHS.synonyms}/${SYNONYMS_PATHS.actions.update}`,
    component: SynonymsForm,
    meta: {
      featureId: FeatureIdEnum.SYNONYM,
      titleI18nKey: 'updateSynonym',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.SYNONYM].list,
    },
  },
]
